import styled, { css } from 'styled-components'

import { desktopCSS, tabletCSS } from '@measures/responsive'

const Wrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing32, spacing16 },
      measures: {
        outerPadding: { tablet: outerPaddingTablet },
      },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing32};

    box-sizing: border-box;
    width: 100%;
    border-radius: ${spacing16};
    padding: ${spacing16} 0;

    ${tabletCSS(css`
      margin-left: calc(${spacing16} - ${outerPaddingTablet});
      margin-right: calc(${spacing16} - ${outerPaddingTablet});
      width: calc(100% + 2 * (${outerPaddingTablet} - ${spacing16}));
    `)}

    ${desktopCSS(css`
      margin: 0 auto;
      width: 632px;
      padding-top: ${spacing32};
    `)}
  `}
`

export default Wrapper
